/*------------------------------------*\
	#NEWSLETTER FORM
\*------------------------------------*/

function initNewsletterForm() {
	const newsletterForms = document.querySelectorAll('.js-newsletter-form'),
		config = {attributes: true, childList: true, subtree: true};

	let callback = mutations => {
		mutations.forEach(mutation => {
			if (mutation.type === 'childList') {
				mutation.addedNodes.forEach(addedNode => {
					addedNode.childNodes.forEach(childNode => {
						if (childNode.tagName === "FORM") {
							childNode.childNodes.forEach(formChildNode => {
								if (formChildNode.tagName === "STYLE") {
									formChildNode.remove();
								}
							});
						}
					});
				});
			}
		})
	}


	const observer = new MutationObserver(callback);

	for (let i = 0; i < newsletterForms.length; i++) {
		observer.observe(newsletterForms[i], config);
	}

}

document.addEventListener("DOMContentLoaded", function () {
	initNewsletterForm();
});
